 

export class Settlement {
    settlement_id!:number; 
    
    settlement_name!:string; 
    settlement_start_date!:Date; 
    settlement_end_date!:Date;
    balance_week_id!:number;
    payment_type = 'cash';

    total_bricks!:number; 
    total_cements!:number;

    subtotal_amount:number = 0;
    previous_balance_amount:number = 0;
    total_advance_amount:number = 0;
    total_amount:number = 0;
    current_payment:number = 0;
    current_balance_amount:number = 0;
    
    created_date!:Date; 
    created_by!:number; 
    updated_date!:Date; 
    updated_by!:number;
    
    instructions: Instruction[] = [];
}


export class Instruction {
    instruction_id!:number; 
    instruction_type!:number; 
    instruction_date!:Date; 
    parent_id!:number; 
    total_brick_6!:number; 
    total_brick_8!:number; 
    brick_rate_6!:number; 
    brick_rate_8!:number; 
    cement_used!:number; 
    advance_amount:number = 0; 
    total_amount:number = 0;
    created_date!:Date; 
    created_by!:number; 
    updated_date!:Date; 
    updated_by!:number; 
    status!:number; 
}

export enum SettlementType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    VIEW = 'VIEW'
}


export enum ViewType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    VIEW = 'VIEW'
}

export enum InvoiceViewType {
    QUICK_VIEW = 'quick',
    IFRAME_VIEW = 'iframe'
}
 

export class SettlementSheet extends Settlement{
    /* settlement: Settlement = new Settlement();
    
    constructor(settlement?:Settlement, dailysheets?: DailySheet[]) { 
        super();
        if(settlement && dailysheets) {
            this.CreateSettlement(settlement,dailysheets);
        } else if(settlement && !dailysheets) {
            this.UpdateSettlement(settlement);
        }
    }

    public setPreviousWeekBalance(balanceAmount: number) {
        this.previous_balance_amount = balanceAmount;
        this.calculateTotalAmount();
    }

    private UpdateSettlement(settlement:Settlement) {
        Object.assign(this,settlement);
    }

    private CreateSettlement(settlement:Settlement,dailysheets:DailySheet[]) {
        Object.assign(this,settlement);
        this.getInstructionFromSheet(dailysheets);
        this.calculateTotalAmount();
    }
    
    public calculateTotalAmount() {
        this.subtotal_amount         = 0;
        this.total_advance_amount    = 0;
        /*this.total_amount            = 0;
        this.current_balance_amount  = 0;
        this.previous_balance_amount = 0;
        this.instructions.forEach( ins => {
            this.subtotal_amount        = Number(this.subtotal_amount) + Number(ins.total_amount);
            this.total_advance_amount   = Number(this.total_advance_amount) + Number(ins.advance_amount);
        })

        this.total_amount           = Number(this.subtotal_amount)
                                        - Number(this.total_advance_amount) + Number(this.previous_balance_amount);
        this.current_balance_amount = Number(this.total_amount) - Number(this.current_payment);

    }

    private getInstructionFromSheet(dailysheets: DailySheet[]): void {
        dailysheets.forEach(sheet => {
            let instruction = new Instruction();
            instruction.instruction_date = sheet.sheet_date;
            instruction.total_brick_6 = sheet.total_bricks_6;
            instruction.total_brick_8 = sheet.total_bricks_8;
            instruction.brick_rate_6 = sheet.bricks_6_rate;
            instruction.brick_rate_8 = sheet.bricks_8_rate;
            instruction.cement_used = sheet.total_cements;
            instruction.advance_amount = sheet.advance_amount;
            instruction.total_amount    = this.getTotalAmountFromSheet(sheet);
            this.instructions.push(instruction);
        });
    }

    private getTotalAmountFromSheet(sheet: DailySheet): number {
         let brick6Cost = 0;
         let brick8Cost = 0;
         
         brick6Cost = Number(sheet.total_bricks_6) * Number(sheet.bricks_6_rate);
         brick8Cost = Number(sheet.total_bricks_8) * Number(sheet.bricks_8_rate);

         return brick6Cost + brick8Cost;
    }*/
    
}